import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DATAS_REFERENCIA, DECLARACAO_EMPFIN, DECLARACAO_RENDIMENTO } from '../../../app.constants';
import { CodigoTributacaoModel } from '../../shared/models/codigoTributacao.model';
import { CodigoTributacaoTotalModel } from '../../shared/models/codigoTributacaoTotal.model';

@Injectable()
export class FinanceiroService {


  constructor(private httpClient: HttpClient) { }

  getListAnos(centrus): Promise<number[]> {
    return this.httpClient
      .get<number[]>(`${DECLARACAO_EMPFIN}/listAnos/${centrus}`)
      .toPromise();
  }


  getDataReferencia(cdCentrus): Promise<string[]> {
    return this.httpClient
      .get<string[]>(`${DATAS_REFERENCIA}/${cdCentrus}`)
      .toPromise();
  }

  getDataReferenciaAssistido(cdCentrus): Promise<string[]> {
    return this.httpClient
      .get<string[]>(`${DATAS_REFERENCIA}/assistido/${cdCentrus}`)
      .toPromise();
  }

  getDeclRendDirfBeanObterDeclDirf(cdCentrus, nrVersao): Promise<CodigoTributacaoModel[]> {
    return this.httpClient
      .get<CodigoTributacaoModel[]>(`${DECLARACAO_RENDIMENTO}/codigoTributacao/${cdCentrus}/${nrVersao}`)
      .toPromise();
  }

  getObterDeclDirfSoma(cdCentrus, nrVersao): Promise<CodigoTributacaoTotalModel[]> {
    return this.httpClient
      .get<CodigoTributacaoTotalModel[]>(`${DECLARACAO_RENDIMENTO}/codigoTributacaoTotais/${cdCentrus}/${nrVersao}`)
      .toPromise();
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/service/financeiro.service.ts